<div class="banner-wrapper-area">
    <div class="slideshow_wraper">
        <div class="home_img_slider">
            @for(item of bannerList; track item; let i = $index){
                <img [src]="item.activeUrl || 'images/logo.png'" alt="Banner Image" />
            }
        </div>
    </div>
    <div class="container">
        <!-- <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="banner-wrapper-content">
                    <h1>Build Skills With Experts Any Time, Anywhere</h1>
                    <p>This is where we teach students skills they need to transform themselves, others, and our global
                        communities.</p>
                    <a (click)="getCourseCategory()" class="default-btn text-aligns-center cursor-pointer">Our Academics<span></span></a>
                    <form>
                        <label><i class='fas fa-angle-down mx-1'></i></label>
                        <input type="text" class="input-search" placeholder="What do you want to learn?">
                        <button type="submit">Search Now</button>
                    </form>
                    <ul class="popular-search-list">
                        <li><span>Popular:</span></li>
                        <li><a routerLink=".">Development</a></li>
                        <li><a routerLink=".">Marketing</a></li>
                        <li><a routerLink=".">Illustration</a></li>
                        <li><a routerLink=".">UX/UI</a></li>
                    </ul> --
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="banner-wrapper-image">
                    <img src="images/banner-img3.png" alt="image">
                    <div class="banner-shape8"><img src="images/banner-shape8.png" alt="image"></div>
                    <div class="banner-shape9"><img src="images/banner-shape9.png" alt="image"></div>
                    <div class="banner-shape10"><img src="images/banner-shape10.png" alt="image"></div>
                </div>
            </div>
        </div> -->
        
        <div class="banner-inner-area">
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-banner-box black-icon">
                        <div class="icon">
                            <i class="fa-solid fa-brain"></i>
                        </div>
                        <h3>10+ Online Courses</h3>
                        <p>Learn anytime, anywhere with expert-led courses.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-banner-box black-icon">
                        <div class="icon">
                            <i class="fa-solid fa-people-group"></i>
                        </div>
                        <h3>Experts Teachers</h3>
                        <p>Experienced, skilled, supportive mentors guiding your learning.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-banner-box black-icon">
                        <div class="icon">
                            <i class="fa-solid fa-earth-americas"></i>
                        </div>
                        <h3>Lifetime Access</h3>
                        <p>Learn forever with unlimited, lifetime course access.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="divider"></div>
</div>

<!-- <div class="slideshow_wrapper">
    <div class="home-img-slider">
        <img src="images/Image-1.png" />
        <img src="images/Image-2.png" />
        <img src="images/Image-3.png" />
    </div>
</div> -->

<!-- <div class="about-area-three ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-12">
                <div class="about-content-box">
                    <span class="sub-title">Distance Learning</span>
                    <h2>Build Your Skills Online, Anytime</h2>
                    <p>Want to learn and earn PDUs or CEUs on your schedule — anytime, anywhere? Or, pick up a new skill
                        quickly like, project team leadership or agile? Browse our most popular online courses.</p>
                    <p><strong>Grow your knowledge and your opportunities with thought leadership, training and
                            tools.</strong></p>
                    <a routerLink="/courses-1" class="default-btn"><i class="flaticon-user"></i>View All
                        Courses<span></span></a>
                </div>
            </div>
            <div class="col-lg-7 col-md-12">
                <div class="about-img">
                    <div class="image">
                        <img src="images/about-img7.png" alt="image">
                        <img src="images/about-img8.png" alt="image">
                    </div>
                    <div class="shape17"><img src="images/shape16.png" alt="image"></div>
                    <div class="shape18"><img src="images/shape17.png" alt="image"></div>
                    <div class="shape19"><img src="images/shape18.png" alt="image"></div>
                    <div class="shape20"><img src="images/shape19.png" alt="image"></div>
                    <div class="shape21"><img src="images/shape20.png" alt="image"></div>
                    <div class="shape22"><img src="images/shape21.png" alt="image"></div>
                    <div class="shape23"><img src="images/shape22.png" alt="image"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="shape3"><img src="images/shape3.png" alt="image"></div>
    <div class="shape4"><img src="images/shape4.png" alt="image"></div>
</div> -->